// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import axios from 'axios'
Vue.prototype.$axios = axios
axios.defaults.baseURL = '/api'  //自动附加在所有axios请求前面，则可以省略/api，直接写'/xxxx/xxx'。否则需要设置'/api/xxxx/xxx'

import Vue from 'vue'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import App from './App'
import router from './router'

// 加载 element 组件库
import ElementUI from 'element-ui'

// 加载 element 组件库的样式
import 'element-ui/lib/theme-chalk/index.css'

import VueLazyload from 'vue-lazyload';
 
//或者自定义配置插件
// Vue.use(VueLazyload);

import animated from 'animate.css'
Vue.use(animated);

Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: 'https://www.xaryxx.com/images/banner/banner6.jpg',
    loading:'https://www.xaryxx.com/images/images2/banneer@2x.jpg' ,
    attempt: 1,
});

// 全局注册 element 组件库
Vue.use(ElementUI)

Vue.config.productionTip = false


router.afterEach((to,from,next)=>{
  window.scrollTo(0,0);
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js